// Single source for the 7-day retention copy. It appears twice in the journey:
//   phase="pre"  — the download step, before the come-back email is sent
//   phase="post" — the DoneScreen, after it's sent
// Same retentionDays + email inputs; only the tense differs. Keeping both
// variants here means a wording or day-count change is one edit, not two that
// can drift apart.
type Props = {
  retentionDays: number;
  /** The address the come-back link goes to (notify-email override, else the
   *  access-code address). Omitted → the sentence drops the "to <addr>" clause. */
  email?: string | null;
  phase: "pre" | "post";
  className?: string;
};

export function RetentionNote({ retentionDays, email, phase, className }: Props) {
  const addr = email ? (
    <>
      {" "}
      to <strong>{email}</strong>
    </>
  ) : null;
  // Load-bearing contrast: the file the user saves is PERMANENT; the 7-day
  // thing is a SEPARATE backup copy we hold. A real user (Lisa, 2026-07-24)
  // read the old "after 7 days it's deleted" as her downloaded file expiring,
  // because it sat right under "this file is your copy." Lead with permanence,
  // then frame the countdown as our backup, and say plainly that deleting the
  // backup doesn't touch her file.
  if (phase === "pre") {
    return (
      <p className={className}>
        The file you save is yours to keep — it never expires. As a backup, we
        also hold a copy for {retentionDays}&nbsp;days and email a link{addr} so
        you can re-download it if anything happens to your file. After{" "}
        {retentionDays}&nbsp;days we delete our backup; the file you downloaded
        and saved to your computer is not affected.
      </p>
    );
  }
  return (
    <p className={className}>
      The file you saved is yours to keep — it never expires. As a backup, we're
      also holding a copy for {retentionDays}&nbsp;days and emailed a link{addr} so
      you can re-download it if anything happens to your file. After{" "}
      {retentionDays}&nbsp;days we delete our backup; the file you downloaded
      and saved to your computer is not affected.
    </p>
  );
}
